import type {
  Filter,
  FilterDataOption,
  FilterDataRange,
  FiltersGroups,
} from '@/app/common/filters/core/filtersTypes.ts';

type ApplyUpdatedFilterProps = {
  prevFiltersGroups: FiltersGroups;
  updatedFilters: Filter[];
};
export const applyUpdatedFilters = ({ prevFiltersGroups, updatedFilters }: ApplyUpdatedFilterProps): FiltersGroups =>
  prevFiltersGroups.map((prevGroup) => {
    if (!('filters' in prevGroup)) return prevGroup;

    return {
      ...prevGroup,
      filters: prevGroup.filters.map((prevFilter) => {
        const updatedFilterNewValue = updatedFilters.find((updatedFilter) => updatedFilter.name === prevFilter.name);
        return updatedFilterNewValue || prevFilter;
      }),
    };
  });

export const isRangeFilterSelected = (filter: Filter): boolean => {
  const filterData = filter.data as FilterDataRange;
  return filterData.value.min !== filterData.default.min || filterData.value.max !== filterData.default.max;
};

type ApplyFiltersDisabledProps = {
  filtersGroups: FiltersGroups;
  disabled: boolean;
};
export const applyFiltersDisabled = ({ filtersGroups, disabled }: ApplyFiltersDisabledProps): FiltersGroups =>
  filtersGroups.map((filterGroup) => {
    if (!('filters' in filterGroup)) return filterGroup;

    return { ...filterGroup, filters: filterGroup.filters.map((filter) => ({ ...filter, disabled })) };
  });

type CreateUpdatedDynamicFiltersProps = {
  prevFilters: Filter[];
  allUpdatedFilters: Filter[];
};
export const createUpdatedDynamicFiltersByOptions = ({
  prevFilters,
  allUpdatedFilters,
}: CreateUpdatedDynamicFiltersProps): Filter[] =>
  prevFilters.map((prevFilter) => {
    const updatedFilter = allUpdatedFilters.find((filter) => filter.name === prevFilter.name);
    if (!updatedFilter) {
      return prevFilter;
    }

    const prevData = prevFilter.data as { options?: FilterDataOption[] };
    const updatedData = updatedFilter.data as { options?: FilterDataOption[] };

    if (prevData.options && updatedData.options) {
      return {
        ...prevFilter,
        ...updatedFilter,
        data: {
          ...updatedFilter.data,
          options: prevData.options.map((prevOption) => {
            const updatedOption = updatedData.options!.find((opt) => opt.value === prevOption.value);
            return updatedOption ? { ...prevOption, ...updatedOption } : prevOption;
          }),
        },
      };
    }

    return updatedFilter;
  });
